/**
 * defa.views.UnitSearchSerialForm
 * A view to search for a unit.
 * @version 1.0.1
 */
import Form from 'scripts/poppet/form';
import template from 'templates/unitSearchSerialForm.jst.html'

const channelLayout = Bb.Radio.channel( 'layout' );
const channelUser   = Bb.Radio.channel( 'user' );

const selectors = {
	inputSearch       : '[data-input=search-serial]',
	buttonHelp        : '[data-click=search-help]',
	buttonRegistry    : '[data-click=search-reg]',
	buttonSubmit      : '[data-click=search-submit]',
	textBluetoothError: '[data-text=search-bluetooth-error]',
};

const UnitSearchSerialForm = Form.extend( {
	
	// ---------------------------------------------------------
	// Setup
	// ---------------------------------------------------------
	
	template        : template,
	noInitValidation: true,
	
	ui: {
		help     : selectors.buttonHelp,
		input    : selectors.inputSearch,
		reg      : selectors.buttonRegistry,
		submit   : selectors.buttonSubmit,
		textError: selectors.textBluetoothError,
	},
	
	events: {
		'focus    @ui.input': 'onFocusInput',
		'click    @ui.input': 'onClickInput',
		'keypress @ui.input': 'onKeypressInput',
		'keydown  @ui.input': 'onKeydownInput',
		'click    @ui.help' : 'onClickHelp',
		'click    @ui.reg'  : 'onClickRegistration',
	},
	
	templateContext: function () {
		return {
			context        : this.options.context || 'setup',
			help           : this.options.help,
			hasCancelButton: this.hasCancelButton(),
		};
	},
	
	// ---------------------------------------------------------
	// Event Handlers
	// ---------------------------------------------------------
	
	/**
	 * Triggers when a user clicks inside the input field.
	 * @void
	 */
	onClickInput: function () {
		this.trimWhitespace();
	},
	
	/**
	 * Triggers when a user clicks the registry text.
	 * @void
	 */
	onClickRegistration: function ( event ) {
		event.preventDefault();
		this.trigger( 'nav', 'unit:search:registration' );
	},
	
	/**
	 * Triggers whent the input field recieves focus.
	 * @void
	 */
	onFocusInput: function () {
		this.trimWhitespace();
	},
	
	/**
	 * Triggers whenever you input something in the serial number field.
	 * @void
	 */
	onKeydownInput: function () {
		
		if ( this.ui.input.val().trim() ) {
			this.enableSubmit();
		} else {
			this.disableSubmit();
		}
		
		this.trimWhitespace();
	},
	
	/**
	 * Triggers whenever you input something in the serial number field.
	 * @void
	 */
	onKeypressInput: function () {
		
		if ( this.ui.input.val().trim() ) {
			this.enableSubmit();
		}
		this.trimWhitespace();
	},
	
	/**
	 * Triggers when the view is attached to the DOM.
	 * @void
	 */
	onAttach: function () {
		let user = channelUser.request( 'model' );
		
		if ( !user.hasRoles( [ 'TECHNICAL_SUPPORT', ] ) ) {
			this.ui.input.inputmask( {
				mask       : '9999  9999  99999999  99  99  ?99  ?99',
				autoclear  : false,
				placeholder: ' ',
			} );
		}
	},
	
	/**
	 * Triggers when a user clicks the "help" button.
	 * @void
	 */
	onClickHelp: function ( event ) {
		event.preventDefault();
		this.trigger( 'nav', 'unit:help' );
	},
	
	
	// ---------------------------------------------------------
	// Functions
	// ---------------------------------------------------------
	
	/**
	 * Informs if we should have a close button or not.
	 * @return {bool}  True if we want a close button, false if not.
	 */
	hasCancelButton: function () {
		return ( 'replace' === this.options.context  || 'accessory' === this.options.context)
	},
	
	/**
	 * Trims the whitespace from the input field.
	 * @void
	 */
	trimWhitespace: function () {
		
		let user = channelUser.request( 'model' );
		
		if ( !user.hasRoles( [ 'TECHNICAL_SUPPORT', ] ) ) {
			this.ui.input.val( this.ui.input.val().trim() );
		}
		
		let errTxt = this.ui.textError;
		
		if ( errTxt.hasClass( 'fade-in' ) ) {
			errTxt
				.removeClass( 'fade-in' )
				.addClass( 'fade-out' );
			
			setTimeout( function () {
				errTxt
					.addClass( 'hidden' )
					.removeClass( 'fade-out' );
			}, 500 );
		}
		
		
	},
	
	/**
	 * Returns true if matching a bluetooth unit.
	 * @returns {bool} True if the unit's serial matches a bluetooth unit, false if not.
	 */
	isBluetoothUnit: function () {
		let serial = this.ui.input.val().trim().replace( /-|\s/g, '' ),
			regexp = /^\d{8}00705250/;
		
		return -1 !== serial.search( regexp );
	},
	
	/**
	 * Tries to find a unit by its serial number.
	 * @void
	 */
	submit: function () {
		
		let serial = this.ui.input.val().trim().replace( /-|\s/g, '' );
		
		if ( !serial ) {
			return;
		}
		
		if ( this.isBluetoothUnit() ) {
			
			if ( !channelLayout.request( 'is:native' ) ) {
				
				this.idle();
				this.disableSubmit();
				this.ui.textError
					.removeClass( 'fade-out' )
					.removeClass( 'hidden' )
					.addClass( 'fade-in' );
				
			} else {
				this.model.fetchBluetooth( {
					serial: serial,
				} );
				
			}
		} else {
			this.model.fetchBySerial( {
				serial : serial,
				context: this.options.context,
			} );
		}
	},
	
} );


export default UnitSearchSerialForm;